import type { IconName } from "@verbleif/lib/src/components/Icon/icons";

export const TASK_VIEW_SIDEBAR_LABEL_KEYS: Record<string, string> = {
  all: "tasks.sidebar.all",
  pinned: "tasks.sidebar.pinned",
  today: "tasks.sidebar.today",
  my_until_today: "tasks.sidebar.open_until_today",
  all_today: "tasks.sidebar.all_today",
  all_until_today: "tasks.sidebar.all_until_today",
  assigned_to_me: "tasks.sidebar.assignedToMe",
  unassigned: "tasks.sidebar.unAssigned",
  route: "tasks.sidebar.route",
  walk_route: "tasks.sidebar.walk_route",
  finished: "tasks.sidebar.typeDone",
  checked: "tasks.sidebar.typeFinished",
  task_list: "tasks.sidebar.per_department",
  per_property: "tasks.sidebar.perObject",
};

export const TASK_VIEW_DEFAULT_ICON: IconName = "list";
export const TASK_VIEW_DEFAULT_ICON_COLOR_CLASS = "text-primary-500 dark:text-primary-400";
